module.exports = __webpack_public_path__ + "img/thumb_04.fc377d8b.jpg";